// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.userrole.CometUserRoleType

export enum CometUserRoleType {
  ACCEPTS_APPLICATIONS = 'acceptsApplications',
  BLOCK_USERS = 'blockUsers',
  CHAT_BOT_BETA = 'chatBotBeta',
  CHECKR_TAC = 'checkrTac',
  /**
   * @deprecated
   */
  CHECKR_TAC_LANDLORD = 'checkrTacLandlord',
  /**
   * @deprecated
   */
  CHECKR_TAC_RENTER = 'checkrTacRenter',
  CIC_CONFIRMATION_RENTER = 'cicConfirmationRenter',
  CIC_TAC = 'cicTac',
  COMET_APPLICATIONS_USER = 'cometApplicationsUser',
  COMET_FEATURES_USER = 'cometFeaturesUser',
  COMET_LEASES_USER = 'cometLeasesUser',
  COMET_MAINTENANCE_USER = 'cometMaintenanceUser',
  COMET_PAYMENTS_USER = 'cometPaymentsUser',
  DELETE_LISTING = 'deleteListing',
  ENTERPRISE_DOWNGRADED_EXPERIENCE = 'enterpriseDowngradedExperience',
  EXPERIAN_CIC_WRITTEN_CONSENT_RENTER = 'experianCicWrittenConsentRenter',
  EXPERIAN_PRIVACY_POLICY = 'experianPrivacyPolicy',
  EXPERIAN_TAC = 'experianTac',
  EXPERIAN_WRITTEN_CONSENT = 'experianWrittenConsent',
  EXPERIAN_WRITTEN_CONSENT_LANDLORD = 'experianWrittenConsentLandlord',
  EXPERIAN_WRITTEN_CONSENT_RENTER = 'experianWrittenConsentRenter',
  HOUSING_CONNECTOR = 'seattleHousingConnector',
  IMPERSONATE = 'impersonate',
  /**
   * @deprecated
   */
  LADMIN = 'ladmin',
  /**
   * @deprecated
   */
  LADMIN_ADMIN = 'ladminAdmin',
  /**
   * @deprecated
   */
  LADMIN_CONSUMER_CARE = 'ladminConsumerCare',
  /**
   * @deprecated
   */
  LADMIN_LAWYER = 'ladminLawyer',
  /**
   * @deprecated
   */
  LADMIN_SALES = 'ladminSales',
  /**
   * @deprecated
   */
  LDQ_MARKETING_USER = 'ldqMarketingUser',
  /**
   * @deprecated
   */
  LDQ_TIER_TWO_AND_THREE_USER = 'ldqTierTwoAndThreeUser',
  LEASING_BETA = 'leasingBeta',
  MANAGE_ROLES = 'manageRoles',
  /**
   * @deprecated
   */
  MARK_USERS_EMAIL_VERIFIED = 'markUsersEmailVerified',
  MULTIFAMILY_CUSTOMER = 'multifamilyCustomer',
  NON_ADVERTISER_CUSTOMER = 'nonAdvertiserCustomer',
  NUCLEUS_CUSTOMER = 'nucleusCustomer',
  /**
   * @deprecated
   */
  PAYMENTS_BETA = 'paymentsBeta',
  PLAID_TAC = 'plaidTac',
  POSTING_PATH_ADMIN = 'postingPathAdmin',
  PREMIUM_CUSTOMER = 'premiumCustomer',
  PROPERTY_MANAGER_ADD_PROPERTY = 'propertyManagerAddProperty',
  PROPERTY_MANAGER_ALL_PROPERTIES = 'propertyManagerAllProperties',
  PROPERTY_MANAGER_COMPANY_ADMIN = 'propertyManagerCompanyAdmin',
  PROPERTY_MANAGER_COMPANY_USER = 'propertyManagerCompanyUser',
  PROPERTY_MANAGER_PAY_INVOICE = 'propertyManagerPayInvoice',
  PROPERTY_MANAGER_RESPOND_TO_REVIEW = 'propertyManagerRespondToReview',
  PROPERTY_MANAGER_UPDATE_LISTING = 'propertyManagerUpdateListing',
  PROPERTY_MANAGER_VIEW_ANALYTICS = 'propertyManagerViewAnalytics',
  PROPERTY_MANAGER_VIEW_INVOICE = 'propertyManagerViewInvoice',
  PROPERTY_MANAGER_VIEW_MESSAGE = 'propertyManagerViewContact',
  ROCKET_SHIP_CUSTOMER = 'rocketShipCustomer',
  SELF_SERVE_CUSTOMER = 'selfServeCustomer',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED = 'rocketShipCustomerCometFeaturesAllowed',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED = 'rocketShipCustomerCometFeaturesRestricted',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES = 'rocketShipCustomerGrantedAccessCometFeatures',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING = 'rocketShipCustomerGrantedAddListing',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING = 'rocketShipCustomerZrmManualListing',
  SINGLE_FAMILY_LEGACY = 'singleFamilyLegacyCustomer',
  TERMS_ACCEPTED_STRIPE = 'termsAcceptedStripe',
  TERMS_ZILLOW_RENTAL_USER = 'termsAcceptedZillowRentalUser',
  ZILLOW_TAC = 'zillowTac',
}

export const CometUserRoleType_values = [
  CometUserRoleType.ACCEPTS_APPLICATIONS,
  CometUserRoleType.BLOCK_USERS,
  CometUserRoleType.CHAT_BOT_BETA,
  CometUserRoleType.CHECKR_TAC,
  CometUserRoleType.CHECKR_TAC_LANDLORD,
  CometUserRoleType.CHECKR_TAC_RENTER,
  CometUserRoleType.CIC_CONFIRMATION_RENTER,
  CometUserRoleType.CIC_TAC,
  CometUserRoleType.COMET_APPLICATIONS_USER,
  CometUserRoleType.COMET_FEATURES_USER,
  CometUserRoleType.COMET_LEASES_USER,
  CometUserRoleType.COMET_MAINTENANCE_USER,
  CometUserRoleType.COMET_PAYMENTS_USER,
  CometUserRoleType.DELETE_LISTING,
  CometUserRoleType.ENTERPRISE_DOWNGRADED_EXPERIENCE,
  CometUserRoleType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER,
  CometUserRoleType.EXPERIAN_PRIVACY_POLICY,
  CometUserRoleType.EXPERIAN_TAC,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT_LANDLORD,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT_RENTER,
  CometUserRoleType.HOUSING_CONNECTOR,
  CometUserRoleType.IMPERSONATE,
  CometUserRoleType.LADMIN,
  CometUserRoleType.LADMIN_ADMIN,
  CometUserRoleType.LADMIN_CONSUMER_CARE,
  CometUserRoleType.LADMIN_LAWYER,
  CometUserRoleType.LADMIN_SALES,
  CometUserRoleType.LDQ_MARKETING_USER,
  CometUserRoleType.LDQ_TIER_TWO_AND_THREE_USER,
  CometUserRoleType.LEASING_BETA,
  CometUserRoleType.MANAGE_ROLES,
  CometUserRoleType.MARK_USERS_EMAIL_VERIFIED,
  CometUserRoleType.MULTIFAMILY_CUSTOMER,
  CometUserRoleType.NON_ADVERTISER_CUSTOMER,
  CometUserRoleType.NUCLEUS_CUSTOMER,
  CometUserRoleType.PAYMENTS_BETA,
  CometUserRoleType.PLAID_TAC,
  CometUserRoleType.POSTING_PATH_ADMIN,
  CometUserRoleType.PREMIUM_CUSTOMER,
  CometUserRoleType.PROPERTY_MANAGER_ADD_PROPERTY,
  CometUserRoleType.PROPERTY_MANAGER_ALL_PROPERTIES,
  CometUserRoleType.PROPERTY_MANAGER_COMPANY_ADMIN,
  CometUserRoleType.PROPERTY_MANAGER_COMPANY_USER,
  CometUserRoleType.PROPERTY_MANAGER_PAY_INVOICE,
  CometUserRoleType.PROPERTY_MANAGER_RESPOND_TO_REVIEW,
  CometUserRoleType.PROPERTY_MANAGER_UPDATE_LISTING,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_ANALYTICS,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_INVOICE,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_MESSAGE,
  CometUserRoleType.ROCKET_SHIP_CUSTOMER,
  CometUserRoleType.SELF_SERVE_CUSTOMER,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING,
  CometUserRoleType.SINGLE_FAMILY_LEGACY,
  CometUserRoleType.TERMS_ACCEPTED_STRIPE,
  CometUserRoleType.TERMS_ZILLOW_RENTAL_USER,
  CometUserRoleType.ZILLOW_TAC,
] as const;
